
import { Constant } from "@/helpers/constant";
import JobAdvancedSearch from "@/models/jobAdvancedSearch";
import CourseAdvancedSearch from "@/models/courseAdvancedSearch";
import { Component, Vue } from "vue-property-decorator";
import JobseekerService from "../../../services/jobseekerService";
import JobpostService from "../../../services/jobpostservice";
import EmployerService from "../../../services/employerService";
import AdminService from "../../../services/adminService";
import { Employer } from "@/models/employer";
import { TopCourses } from "@/models/courses";
import EmployerAttachments from "@/models/employerAttachments";
import {TranslateEn} from "@/languages/translate_en";
import {TranslateMalay} from "@/languages/translate_malay";
import { CarouselData } from "@/helpers/carouselData";
import Tabs from 'vue-tabs-with-active-line';
import UpSkillService from "../../../services/upSkillService";
import GoTop from '@inotom/vue-go-top';
import { LightGallery } from 'vue-light-gallery';
import CourseCard from "@/components/courseCard/courseCard.vue";
import SatelliteEventCard from "@/components/satelliteEventCard/satelliteEventCard.vue";

import RandomImageService  from "../../../services/randomImageService";
import Galleria from 'primevue/galleria';
import upSkillService from "../../../services/upSkillService";


@Component({  components: {
    Tabs,
    GoTop,
    LightGallery,
    CourseCard,
    SatelliteEventCard,
    Galleria,
  },
  // data() {
  //   // Define the total number of images
  //   const totalImages = 33;

  //   // Generate an array of numbers from 1 to 33
  //   const imageIndexes = Array.from({ length: totalImages }, (_, index) => index + 1);

  //   // Map over the image indexes and create objects with title and url properties
  //   const images = imageIndexes.map((index) => ({
  //     title: '',
  //     // Use require to resolve the image path
  //     url: require(`../../../assets/ntw/gallery/${index}.jpg`),
  //   }));

  //   return {
  //     images,
  //     // Use require to directly include the thumbnails
  //     thumbs: imageIndexes.map((index) => require(`../../../assets/ntw/gallery/${index}.jpg`)),
  //     index: null,
  //   };
  // },
})
export default class Home extends Vue {
  product = null;
  option = null;
  jobsearch: JobAdvancedSearch = new JobAdvancedSearch();
  skillError: boolean = false;
  $loading: any;
  totalJobseekerCount: number = 0;
  totalPostJobCount: number = 0;
  totalCompaniesCount: number = 0;
  page: number = 1;
  totalApprovedEmployerCount: number = 0;
  totalJobVacancies: number = 0;
  totalAvailableCourses: number = 0;
  totalAvailableTrainingProvider: number = 0;
  totalAvailableApplication: number = 0;
  totalAvailableAgency: number = 0;
  totalKeySkills: number = 0;
  employers: Employer[] = [];
  topCourses: TopCourses[] = [];
  searchType = "Courses";
  upskillAgencyLoginUrl = Constant.upskill_agency_login_url;
  homePageData: any;
  homePageData1: any;
  selectedLanguage: string ='';
  cardItem: any = CarouselData.cardItem;
  skillsItem: any = CarouselData.skillsItem;
  skillsListingData: any = [];
  currentTab:any= '1';
  cat_id: 1;
  coursesearch: CourseAdvancedSearch = new CourseAdvancedSearch();
  allcourses: CourseAdvancedSearch = new CourseAdvancedSearch();
  searchkeyword: any ='';
  tabs:any= [
  { title: 'All', value: '1' },
  { title: 'Premier', value: '2' },
  { title: 'Intermediate', value: '3' },
  { title: 'Fundamental', value: '4' },
  // { title: 'E-Learning', value: '5' },
    // { title: 'Entrepreneurship/GIG', value: '1' },
    // { title: 'Job Placement', value: '2' },
    // { title: 'Skill Improvement', value: '3', }
    ];
  
  eLearningData:any= [];
  states:any= [];
  events:any= [];
  stateOptions = [];
  selectedState = 'Klang Valley';
  bannerList:any = [];
  totalPageVisit: number = 0;

    //References
    //https://madewithvuejs.com/vue-slick-carousel
    //https://gs-shop.github.io/vue-slick-carousel/?ref=madewithvuejs.com#/example/adaptive-height
    responsiveOptions:any[]= [
    {
      breakpoint: '1024px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '900px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '700px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  responsiveOptionsTopCarousel:any[]= [
    {
      breakpoint: '1024px',
      numVisible: 3,
      numScroll: 3
    },
    {
      breakpoint: '900px',
      numVisible: 3,
      numScroll: 3
    },
    {
      breakpoint: '770px',
      numVisible: 2,
      numScroll: 2
    },
    {
      breakpoint: '690px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '375px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  courseList: any=[];
  trendingList: any=[];
  evenSkilData: any = [];
  oddSkilData: any = [];
  courseLength: any=null;
  trendingCourseLength: any=null;
  satelliteEventsLength: any=null;
  homePageDataOverview: any;
  homePageDataObjectives: any;
  homePageDataPillars: any;
  homePageDataTargetGroups: any;
  homePageDataBenefits: any;
  courseSection: any;
  onlineCourses: any;
  trendingOnlineCourses: any;
  satelliteEvents: any;
  homePageDataSocial: any;
  eventsLength: any=null;
  
    handleClick(newTab) {
      this.courseList = []
      this.currentTab = newTab;
      if (this.currentTab == 1){
        this.getTotalCoursesDetails('');
      } else if (this.currentTab == 2){
        this.getTotalCoursesDetails('premium');
      } else if (this.currentTab == 3){
        this.getTotalCoursesDetails('intermediate');
      } else if (this.currentTab == 4){
        this.getTotalCoursesDetails('fundamental');
      } else if (this.currentTab == 5){
        this.getTotalCoursesDetails('elearning');
      }
      this.cat_id=1
    }


    handleBannerClick(url){
      //alert('test clickable in each banner')
      window.open(url);
    }

  created() {
    localStorage.setItem("homeSearch",'');
    if (
      localStorage.getItem("loginType") != undefined &&
      localStorage.getItem("loginType") != null &&
      localStorage.getItem("loginType") != "" &&
      localStorage.getItem("bearerToken") != undefined &&
      localStorage.getItem("bearerToken") != null
    ) {
      let loginType = localStorage.getItem("loginType");
      let bearerToken = localStorage.getItem("bearerToken");
      if (loginType == "employer") {
        this.getEmployer();
      } else if (loginType == "jobseeker") {
        this.getJobseeker();
      } else if (loginType == "admin") {
        this.getAdmin();
      }
    } else {
      window.addEventListener("keyup", this.captureEnterEvent);
     
      // this.getTotalJobssekersCount();
      // this.getTotalPostJobscount();
      // this.getTotalCompaniesCount();
      // this.getTotalJobVacancies();
      // this.getApprovedEmployers();
    }
      this.getTotalCoursesCount();
      this.getTotalCoursesDetails('');
      this.getAllSkills();
      this.getSatelliteEventsRegion();
      // this.getElearningTrendingCourse();
      // this.getTopCourses();
      this.getTrendingCoursesDetails('');
      this.getPageVisitCount();
      this.getPartners();

    if(localStorage.getItem("selectedlanguage") != undefined && localStorage.getItem("selectedlanguage") != null){
      this.selectedLanguage = localStorage.getItem("selectedlanguage");
      }else{
        localStorage.setItem("selectedlanguage", 'en');
        this.selectedLanguage = "en";
      }

      this.getBanner();
      
    if(this.selectedLanguage == 'en')
    {
      this.homePageData = TranslateEn.homePageData;
      this.homePageDataOverview = TranslateEn.homePageDataOverview;
      this.homePageDataObjectives = TranslateEn.homePageDataObjectives;
      this.homePageDataPillars = TranslateEn.homePageDataPillars;
      this.homePageDataTargetGroups = TranslateEn.homePageDataTargetGroups;
      this.homePageDataBenefits = TranslateEn.homePageDataBenefits;
      this.courseSection = TranslateEn.courseSection;
      this.onlineCourses = TranslateEn.onlineCourses;
      this.trendingOnlineCourses = TranslateEn.trendingOnlineCourses;
      this.satelliteEvents = TranslateEn.satelliteEvents;
      this.homePageDataSocial = TranslateEn.homePageDataSocial;
      this.searchType = 'Courses';
      this.tabs = [
      { title: 'All', value: '1' },
      { title: 'Premier', value: '2' },
      { title: 'Intermediate', value: '3' },
      { title: 'Fundamental', value: '4' },
      // { title: 'E-Learning', value: '5' },
      ]
    }
    else{
      this.homePageData = TranslateMalay.homePageData;
      this.homePageDataOverview = TranslateMalay.homePageDataOverview;
      this.homePageDataObjectives = TranslateMalay.homePageDataObjectives;
      this.homePageDataPillars = TranslateMalay.homePageDataPillars;
      this.homePageDataTargetGroups = TranslateMalay.homePageDataTargetGroups;
      this.homePageDataBenefits = TranslateMalay.homePageDataBenefits;
      this.courseSection = TranslateMalay.courseSection;
      this.onlineCourses = TranslateMalay.onlineCourses;
      this.trendingOnlineCourses = TranslateMalay.trendingOnlineCourses;
      this.satelliteEvents = TranslateMalay.satelliteEvents;
      this.homePageDataSocial = TranslateMalay.homePageDataSocial;
      this.searchType = 'Courses';
      this.tabs = [
      { title: 'Semua', value: '1' },
      { title: 'Premier', value: '2' },
      { title: 'Peringkat Pertengahan', value: '3' },
      { title: 'Peringkat Asas', value: '4' },
      // { title: 'E-Pembelajaran', value: '5' },
      ]

    }
    this.cardItem=this.cardItem[0].data;
    this.skillsItem=this.skillsItem[0].data;

    // this.eLearningData = [
    //   { image: require('../../../assets/ntw/udemy.png'), link: 16, desc1: this.selectedLanguage == 'en' ? 'Udemy' : 'Udemy', desc2: this.selectedLanguage == 'en' ? '(24,000+ Courses)' : '(24,000+ Kursus)', desc3: this.selectedLanguage == 'en' ? "" : ''},
    //   { image: require('../../../assets/ntw/awantec.png'), link: 1, desc1: this.selectedLanguage == 'en' ? 'Awantec Systems' : 'Awantec Systems', desc2: this.selectedLanguage == 'en' ? '(22,000+ Courses)' : '(22,000+ Kursus)', desc3: this.selectedLanguage == 'en' ? 'Leverage your new skills and knowledge with Percipio Skillsoft, which offers more than 22,000+ courses, over 800+ skills benchmarks self-assessment and 160 professional certification journey.' : 'Tingkatkan kemahiran dan pengetahuan baharu anda dengan Percipio Skillsoft, yang menawarkan lebih daripada 22,000 kursus, lebih 800 penanda aras penilaian kemahiran, dan 160 pensijilan profesional.'},
    //   { image: require('../../../assets/ntw/microsoft.png'), link: 15, desc1: this.selectedLanguage == 'en' ? 'Microsoft' : 'Microsoft', desc2: this.selectedLanguage == 'en' ? '(4,500+ Courses)' : '(4,500+ Kursus)', desc3: this.selectedLanguage == 'en' ? "Microsoft provides globally renowned and accredited digital and technical certification courses from Cloud and IOT to Data &AI to Security and more!" : 'Kami menyediakan Kursus pensijilan digital dan teknikal yang diiktiraf secara global dari Cloud dan IoT hingga Data & AI dan Keselamatan, serta banyak lagi'},
    //   { image: require('../../../assets/ntw/reskills.png'), link: 2, desc1: this.selectedLanguage == 'en' ? 'ReSkills Edtech' : 'ReSkills Edtech', desc2: this.selectedLanguage == 'en' ? '(4,000+ Courses)' : '(4,000+ Kursus)', desc3: this.selectedLanguage == 'en' ? "Join ReSkills today to access over 2,500 interactive courses led by industry experts, featuring real-time classes, case studies, and role plays. Experience affordable, accessible learning from anywhere, and start your journey for free to elevate your career with ReSkills!" : 'Sertai ReSkills hari ini untuk akses lebih daripada 2,500 kursus interaktif oleh pakar industri, termasuk kelas secara lansung , kajian kes, dan role-play. Alami pembelajaran fleksibel dan percuma, dan tingkatkan kerjaya dengan ReSkills.'},
    //   { image: require('../../../assets/ntw/outclass.png'), link: 26, desc1: this.selectedLanguage == 'en' ? 'Outclass' : 'Outclass', desc2: this.selectedLanguage == 'en' ? '(2500+ Courses)' : '(2500+ Kursus)', desc3: this.selectedLanguage == 'en' ? "Outclass is a learning experience platform that offers a holistic and personalised approach to learning and career development. It combines on-demand content with goal-oriented learning paths, tailored for individuals and professionals alike." : 'Outclass ialah platform pembelajaran yang memberikan pendekatan menyeluruh dan peribadi untuk pembelajaran dan perkembangan kerjaya. Ia menggabungkan "on-demand" dengan laluan pembelajaran yang disesuaikan untuk memenuhi keperluan individu dan profesional.'},
    //   { image: require('../../../assets/ntw/GarrantoAcademyLogo.png'), link: 27, desc1: this.selectedLanguage == 'en' ? 'Garranto Academy' : 'Garranto Academy', desc2: this.selectedLanguage == 'en' ? '(48 Courses)' : '(48 Kursus)', desc3: this.selectedLanguage == 'en' ? 'From beginners to experienced professionals, Fin2u offers a diverse courses in finance, self-help, engineering, and digital courses,empowering you to thrive in a rapidly changing world.' : 'Dari peringkat permulaan hingga profesional, Fin2u menawarkan pelbagai kursus dalam bidang kewangan, pembangunan diri, kejuruteraan, dan kursus digital, membantu anda untuk berjaya dalam dunia yang sentiasa berubah.'},
    //   { image: require('../../../assets/ntw/Fin2U.png'), link: 5, desc1: this.selectedLanguage == 'en' ? 'Fin2u Digital' : 'Fin2u Digital', desc2: this.selectedLanguage == 'en' ? '(18 Courses)' : '(18 Kursus)', desc3: this.selectedLanguage == 'en' ? 'From beginners to experienced professionals, Fin2u offers a diverse courses in finance, self-help, engineering, and digital courses,empowering you to thrive in a rapidly changing world.' : 'Dari peringkat permulaan hingga profesional, Fin2u menawarkan pelbagai kursus dalam bidang kewangan, pembangunan diri, kejuruteraan, dan kursus digital, membantu anda untuk berjaya dalam dunia yang sentiasa berubah.'},
    //   { image: require('../../../assets/ntw/eQuickLearn.png'), link: 4, desc1: this.selectedLanguage == 'en' ? 'eQuick Learn' : 'eQuick Learn', desc2: this.selectedLanguage == 'en' ? '(10 Courses)' : '(10 Kursus)', desc3: this.selectedLanguage == 'en' ? 'eQuick Learn is a leading supplier of localized e-Learning programs in SCORM and xAPI formats to corporate sectors in Malaysia. We offer a variety of professional courses and micro-learning, including project management, mental wellness, and specialized workplace training such as customer service and food safety.' : 'eQuick Learn adalah pembekal utama program e-Pembelajaran yang disesuaikan dalam format SCORM dan xAPI kepada sektor korporat di Malaysia. Kami menawarkan pelbagai kursus profesional dan pembelajaran mikro, termasuk pengurusan projek, kesejahteraan mental, serta latihan khusus di tempat kerja seperti perkhidmatan pelanggan dan keselamatan makanan'},
    //   { image: require('../../../assets/ntw/asea-tech.png'), link: 28, desc1: this.selectedLanguage == 'en' ? 'Asea-Tech' : 'Asea-Tech', desc2: this.selectedLanguage == 'en' ? '(8 Courses)' : '(8 Kursus)', desc3: this.selectedLanguage == 'en' ? "" : ''},
    //   { image: require('../../../assets/ntw/ebox.svg'), link: 22, desc1: this.selectedLanguage == 'en' ? 'eBOX' : 'eBOX', desc2: this.selectedLanguage == 'en' ? '(6 Courses)' : '(6 Courses)', desc3: this.selectedLanguage == 'en' ? "E-Box offers a variety of programs including skill development courses, industry-aligned certifications, and project-based learning. Their offerings cater to students, professionals, and institutions, focusing on enhancing technical and soft skills through interactive and hands-on training modules." : 'E-Box menawarkan pelbagai program yang termasuk kursus pembangunan kemahiran, pensijilan selaras industri, dan pembelajaran berasaskan projek. Program mereka ditujukan kepada pelajar, profesional, dan institusi, dengan fokus untuk meningkatkan kemahiran teknikal dan "soft-skills" melalui modul latihan interaktif dan praktikal.'},
    //   { image: require('../../../assets/ntw/trainocate.png'), link: 25, desc1: this.selectedLanguage == 'en' ? 'Trainocate' : 'Trainocate', desc2: this.selectedLanguage == 'en' ? '(6 Courses)' : '(6 Kursus)', desc3: this.selectedLanguage == 'en' ? '' : ''},
    //   { image: require('../../../assets/ntw/alibaba.png'), link: 6, desc1: this.selectedLanguage == 'en' ?  'Alibaba Cloud' : 'Alibaba Cloud', desc2: this.selectedLanguage == 'en' ? '(4 Courses)' : '(4 Kursus)', desc3: this.selectedLanguage == 'en' ? 'Dive into Alibaba Cloud with our immersive training sessions and public classes, exploring OSS, ECS, SLB, and Alibaba Cloud Services. Gain the knowledge and certification needed to harness these technologies with confidence.' : 'Jelajahi dunia dinamik Alibaba Cloud melalui sesi latihan mendalam dan kelas awam kami, mempelajari OSS, ECS, SLB, dan Perkhidmatan Alibaba Cloud. Dapatkan kemahiran dan pensijilan yang diperlukan untuk menguasai teknologi Alibaba Cloud.'},
    //   { image: require('../../../assets/ntw/mydigital-corp.png'), link: 29, desc1: this.selectedLanguage == 'en' ? 'MyDIGITAL Corporation' : 'MyDIGITAL Corporation', desc2: this.selectedLanguage == 'en' ? '(3 Courses)' : '(3 Kursus)', desc3: this.selectedLanguage == 'en' ? "" : ''},
    //   { image: require('../../../assets/ntw/elearningminds.png'), link: 19, desc1: this.selectedLanguage == 'en' ? 'eLearningMinds ' : 'eLearningMinds', desc2: this.selectedLanguage == 'en' ? '(3 Courses)' : '(3 Kursus)', desc3: this.selectedLanguage == 'en' ? "eLearningMinds is a leading provider of digital learning solutions for private and public sectors. With global strategic partnerships, we offer a comprehensive range of eLearning content design, strategic consultancy, and digital platform implementation. Our focus on sustainability and engagement ensures effective and enjoyable learning." : 'eLearningMinds adalah peneraju utama dalam penyelesaian pembelajaran digital untuk sektor swasta dan awam. Melalui kerjasama strategik global, kami menawarkan pelbagai perkhidmatan komprehensif dalam reka bentuk kandungan eLearning, perundingan strategik, dan pelaksanaan platform digital. Fokus kami pada kelestarian dan interaksi memastikan pembelajaran yang berkesan dan menyeronokkan.'},
    //   { image: require('../../../assets/ntw/Mereka-Innovative-Education.png'), link: 30, desc1: this.selectedLanguage == 'en' ? 'Mereka Innovative Education' : 'Mereka Innovative Education', desc2: this.selectedLanguage == 'en' ? '(1 Courses)' : '(1 Kursus)', desc3: this.selectedLanguage == 'en' ? "" : ''},
    //   { image: require('../../../assets/ntw/knolskape.png'), link: 20, desc1: this.selectedLanguage == 'en' ? 'Knolskape Solutions' : 'Knolskape Solutions', desc2: this.selectedLanguage == 'en' ? '(1 Course)' : '(1 Kursus)', desc3: this.selectedLanguage == 'en' ? "Knolskape courses incorporate experiential learning through simulations, assessments, interactive videos, gamification, and customized journeys. These elements address key learning needs for the future workforce, such as Digital Transformation, Strategy, Design Thinking, Agile, Cross-level Leadership, and Data." : 'Kursus Knolskape mengandungi elemen pembelajaran melalui simulasi, penilaian, video interaktif, gamifikasi, dan pembelajaran yang dipersonalisasi. Elemen-elemen ini memenuhi keperluan pembelajaran penting untuk tenaga kerja masa depan seperti Digital Transformation, Strategy, Design Thinking, Agile, Cross-level Leadership, and Data.'},
    //   { image: require('../../../assets/ntw/eLatih.png'), link: 3, desc1: this.selectedLanguage == 'en' ? 'e-LATiH' : 'e-LATiH', desc2: this.selectedLanguage == 'en' ? '(1,800+ Courses)' : '(1,800+ Kursus)', desc3: this.selectedLanguage == 'en' ? "e-LATiH offers over 2,000 free courses across 27 skill areas. Whether you're looking to advance in digital technologies, learn a new language, or develop personally, e-LATiH has the resources to help you achieve your goals. Unlock your potential with e-LATiH today!" : 'e-LATiH menawarkan lebih daripada 2,000 kursus percuma dalam 27 bidang kemahiran. Sama ada anda ingin memajukan diri dalam teknologi digital, mempelajari bahasa baru, atau mengembangkan potensi diri, e-LATiH mempunyai sumber yang dapat membantu anda mencapai matlamat anda.'},
    //   // { image: require('../../../assets/ntw/linkedin.png'), link: 11, desc1: this.selectedLanguage == 'en' ? 'LinkedIn Learning (30+ Courses)' : 'LinkedIn Learning (30+ Kursus)', desc2: this.selectedLanguage == 'en' ? 'Available from 24 June until 18 July 2024' : 'Bermula dari 24 Jun hingga 18 Julai 2024', desc3: this.selectedLanguage == 'en' ? "LinkedIn Learning is an online platform offering a wide range of expert-led courses covering topics like business, technology, and personal development. Users can learn at their own pace, access courses from any device, and showcase their skills on their LinkedIn profiles" : 'LinkedIn Learning ialah platform dalam talian yang menawarkan pelbagai kursus yang dikendalikan oleh pakar dalam bidang perniagaan, teknologi, dan pembangunan diri. Pengguna boleh belajar mengikut keselesaan mereka, mengakses kursus dari mana-mana peranti, dan mempamerkan kemahiran mereka di profil LinkedIn.'},
    //   // { image: require('../../../assets/ntw/harvard.png'), link: 10, desc1: this.selectedLanguage == 'en' ? 'Harvard Business School Publishing Corporate Learning (5+ Courses)' : 'Harvard Business School Publishing Corporate Learning (5+ Kursus)', desc2: this.selectedLanguage == 'en' ? '(10 Courses)' : '(2500+ Kursus)', desc3: this.selectedLanguage == 'en' ? "Discover Harvard's Leadership and Management Development courses, offering practical insights for leading yourself, teams, others, and the business. Crafted by Harvard Business School Professors and the Editorial Team, each course emphasizes applying new knowledge to daily work, ensuring effective learning transfer." : 'Jelajahi kursus Pembangunan Kepimpinan dan Pengurusan dari Harvard yang menyediakan panduan praktikal untuk memimpin diri sendiri, pasukan, individu lain, dan perniagaan. Kursus-kursus ini dibangunkan oleh Profesor Harvard Business School dan Pasukan Editorial, dengan penekanan pada penerapan pengetahuan baru dalam kerja seharian untuk pembelajaran yang berkesan.'},
    //   // { image: require('../../../assets/ntw/accenture.png'), link: 12, desc1: this.selectedLanguage == 'en' ? 'Accenture Academy (5+ Courses)' : 'Accenture Academy (5+ Kursus)', desc2: this.selectedLanguage == 'en' ? 'Available from 8 June until 30 June 2024' : 'Bermula dari 8 Jun hingga 30 Jun 2024', desc3: this.selectedLanguage == 'en' ? "Stay ahead of the curve and future-proof your career with Accenture Academy's premium e-learning content, which focuses on Digital Fluency, Cybersecurity, and Sustainability learning content. Master these critical areas of success that is vital for thriving in the digital era while advocating for sustainability and responsible citizenship" : 'Kekal di hadapan dan jamin masa depan kerjaya anda dengan kandungan e-pembelajaran premium dari Accenture Academy. Fokus kepada "Digital Fluency, Cybersecutiry  dan kursus Sustainability .Kuasai bidang-bidang penting ini yang menjadi kunci kejayaan dalam era digital, sambil mengamalkan kelestarian dan sikap kewarganegaraan yang bertanggungjawab.'},
    //   // { image: require('../../../assets/ntw/udacity.jpg'), link: 13, desc1: this.selectedLanguage == 'en' ? 'Udacity (4 Courses)' : 'Udacity (4 Kursus)', desc2: this.selectedLanguage == 'en' ? '(10 Courses)' : '(2500+ Kursus)', desc3: this.selectedLanguage == 'en' ? "Specialises in tech-focused courses and nanodegree programs developed in partnership with industry leaders, offering hands-on projects and personalized feedback from mentors." : 'Mengkhusus dalam kursus teknologi dan program nanodegree yang dibangunkan bersama pemimpin industri, menawarkan projek praktikal serta maklum balas peribadi daripada mentor.'},
    //   // { image: require('../../../assets/ntw/futurelearn.png'), link: 17, desc1: this.selectedLanguage == 'en' ? 'FutureLearn (80+ Courses)' : 'FutureLearn (80+ Kursus)', desc2: this.selectedLanguage == 'en' ? '(10 Courses)' : 'Bermula dari 24 Jun hingga 30 Julai 2024', desc3: this.selectedLanguage == 'en' ? "FutureLearn is a world-leading career-focused lifelong learning platform that accelerates professional growth through online courses. We fundamentally believe in the transformative power of education and its potential to foster a more inclusive and diverse global society" : 'FutureLearn adalah platform pembelajaran sepanjang hayat dengan fokus pada kerjaya, yang meningkatkan perkembangan profesional melalui kursus dalam talian. Kami percaya dengan kuasa transformasi pendidikan dan potensinya untuk memupuk masyarakat global yang lebih inklusif dan pelbagai.'},
    //   // { image: require('../../../assets/ntw/openlearning.png'), link: 18, desc1: this.selectedLanguage == 'en' ? 'Openlearning Global (5 Courses)' : 'Openlearning Global (5 Kursus)', desc2: this.selectedLanguage == 'en' ? 'Available from 19 June until 11 December 2024' : 'Bermula dari 19 Jun hingga 11 Disember 2024', desc3: this.selectedLanguage == 'en' ? "OpenLearning is an AI-powered SaaS platform for lifelong learning, empowering education providers worldwide with advanced course management and delivery solutions, revolutionizing global education accessibility." : 'OpenLearning merupakan platform SaaS yang menggunakan AI untuk pembelajaran sepanjang hayat, yang memperkasakan penyedia pendidikan global dengan solusi pengurusan dan penghantaran kursus yang canggih, merevolusikan aksesibiliti pendidikan global.'},
    //   // { image: require('../../../assets/ntw/diri.png'), link: 8, desc1: this.selectedLanguage == 'en' ? 'DIRI Technologies (2 Courses)' : 'DIRI Technologies (2 Kursus)', desc2: this.selectedLanguage == 'en' ? '(10 Courses)' : '(2500+ Kursus)', desc3: this.selectedLanguage == 'en' ? "We are DIRI, a self-paced online learning platform for Malaysians, offering top e-learning development with local celebrity mentors and cinematic-quality courses to educate, entertain, and inspire." : 'Kami adalah DIRI, platform pembelajaran dalam talian untuk rakyat Malaysia, menawarkan e-pembelajaran terbaik dengan mentor selebriti tempatan dan kursus berkualiti sinematik untuk mendidik, menghibur, dan memberi inspirasi.'},
    //   // { image: require('../../../assets/ntw/metalloy.png'), link: 7, desc1: this.selectedLanguage == 'en' ? 'Metalloy Consultant (2 Courses)' : 'Metalloy Consultant (2 Kursus)', desc2: this.selectedLanguage == 'en' ? '(10 Courses)' : '(2500+ Kursus)', desc3: this.selectedLanguage == 'en' ? 'We provide technical know-how and applied engineering theory to the manufacturing and education industries through public and in-house training courses, technical learning tours, and the marketing of technical publications.' : 'Kami menyediakan pengetahuan teknikal dan teori kejuruteraan praktikal untuk industri pembuatan dan pendidikan melalui kursus latihan public dan in-house, lawatan pembelajaran teknikal, dan pemasaran bahan penerbitan teknikal.'},
    //   // { image: require('../../../assets/ntw/emeritus.png'), link: 14, desc1: this.selectedLanguage == 'en' ? 'Emeritus Insights (400+ Courses)' : 'Emeritus Insights (400+ Kursus)', desc2: this.selectedLanguage == 'en' ? 'Available from 24 June until 31 December 2024' : 'Bermula dari 24 Jun hingga 31 Disember 2024', desc3: this.selectedLanguage == 'en' ? "Emeritus Insights is a daily learning platform to learn and upskill anytime, anywhere with 5000+ bite-sized video lessons from best-selling books, world's top universities, subject matter experts & global thought leaders. Build 50+ key skills like leadership, strategy, communication, productivity, data science, marketing, negotiation, and others on the go to shape your success." : 'Emeritus Insights adalah platform pembelajaran harian yang membolehkan anda belajar dan meningkatkan kemahiran dengan lebih daripada 5000 video daripada buku terlaris, universiti terkemuka, pakar dalam bidang tertentu, dan pemimpin global. Kami menawarkan lebih daripada 50 kemahiran kunci seperti kepimpinan, strategi, komunikasi, produktiviti, sains data, pemasaran, rundingan, dan lain-lain untuk membentuk kejayaan anda.'},
    //   // { image: require('../../../assets/ntw/coursera.png'), link: 21, desc1: this.selectedLanguage == 'en' ? 'Coursera (3 Courses)' : 'Coursera (3 Kursus)', desc2: this.selectedLanguage == 'en' ? 'Available from 24 June until 7 July 2024' : 'Bermula dari 24 Jun hingga 7 Julai 2024', desc3: this.selectedLanguage == 'en' ? "Coursera offers a wide range of online courses, specializations, certificates, and degree programs from top universities and companies worldwide. It covers various subjects, including computer science, business, health, arts, and more." : 'Coursera menyediakan pelbagai kursus dalam talian, pengkhususan, sijil, dan program ijazah daripada universiti dan syarikat terkemuka di seluruh dunia. Ia merangkumi pelbagai bidang, termasuk sains komputer, perniagaan, kesihatan, seni, dan banyak lagi'},
    //   // { image: require('../../../assets/ntw/edx.png'), link: 23, desc1: this.selectedLanguage == 'en' ? 'edX (3 Courses)' : 'edX (3 Kursus)', desc2: this.selectedLanguage == 'en' ? 'Available from 1 July until 31 July 2024' : 'Bermula dari 1 Julai hingga 31 Julai 2024', desc3: this.selectedLanguage == 'en' ? "edX is the online learning platform from world-leading digital education company 2U, Inc. edX connects over 86 million people worldwide with online learning that delivers real professional progress across nearly every career discipline, from artificial intelligence and robotics to sustainability and public health provided by universities and organizations at the forefront of their fields." : 'edX adalah platform pembelajaran dalam talian daripada syarikat pendidikan digital terkemuka dunia, 2U, Inc. edX menghubungkan lebih daripada 86 juta orang di seluruh dunia dengan pembelajaran dalam talian yang memberikan kemajuan profesional sebenar dalam hampir setiap disiplin kerjaya, daripada artificial intelligence (AI) dan robotik hingga kemampanan dan kesihatan awam yang ditawar oleh universiti dan organisasi terkemuka.'},
    //   // { image: require('../../../assets/ntw/rosen.png'), link: 24, desc1: this.selectedLanguage == 'en' ? 'Avernoble (3+ Courses)' : 'Avernoble (3+ Kursus)', desc2: this.selectedLanguage == 'en' ? 'Available from 25 June until 31 July 2024' : 'Bermula dari 25 Jun hingga 31 Julai 2024', desc3: this.selectedLanguage == 'en' ? "ROSEN’s Competence Club is the pipeline industry’s premier learning and collaboration platform. The e-learning courses are self-paced online training materials that provide 24/7 accessibility to pipeline integrity training and feature a variety of media, including videos, interviews, presentations and micro-courses. " : "ROSEN's Competence Club ialah platform pembelajaran dan kerjasama terunggul dalam industri saluran paip. Kursus -kursus tersedia adalah kursus e-pembelajaran yang mengikut kadar sendiri yang menyediakan aksesibiliti 24/7 kepada latihan integriti saluran paip dan menampilkan pelbagai media, termasuk video, wawancara, pembentangan dan mikro-kursus."},
    // ]

    // this.bannerList = [
    //   { image: require('../../../assets/2025/Homepage Banner@2x.png'), link: 1},
    //   { image: require('../../../assets/2025/Pitch & Grow Updated Banner.jpg'), link: 2},
    // ]


  }
  computed(){
    this.filteredItems();
  }
  filteredItems() {
     return this.courseList.slice(0, 3)
    }
  search(type) {
    this.searchType = type;
  }

  getTotalJobVacancies() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
    };
    JobpostService.getTotalVacanciesForHomepage(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null
          )
            if (response.data.data.count != null) {
              this.totalJobVacancies = response.data.data.count;
            } else {
              this.totalJobVacancies = 0;
            }
        }
      }
    });
  }
   getAllSkills() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.ADMIN_PROVIDER,
    };
    UpSkillService.getAllSkills(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (response.data != undefined && response.data != null )
           {
             let firstObj ={};
             let seconObj = {};
             this.skillsListingData = response.data.data;
              for (let index = 0; index < this.skillsListingData.length; index++) {
                 if ( index % 2 == 0 ){
                       this.evenSkilData.push(this.skillsListingData[index]);
                      
                  } else{
                       this.oddSkilData.push(this.skillsListingData[index]);
                        
                  }
                             
              }

           }
        }
      }
    });
  }

  searchCourseByCatagory(categoryId){
    // this.coursesearch = new CourseAdvancedSearch();
    // this.coursesearch.categoryName = categoryName;
    localStorage.setItem("courseind", "category");
    localStorage.setItem("seachCatagoryName", categoryId);
    localStorage.setItem("dashboardSearch", this.searchType);
    this.$router.push("/innerPage");
  }

skillredirect(id:any){
      localStorage.setItem("skilfilterid", id);
    this.$router.push("/courseList");
}
  getAllCourses(provider){
    this.allcourses = new CourseAdvancedSearch();
    this.allcourses.provider = provider;
    localStorage.setItem("courseind", "allcourses");
    localStorage.setItem("dashboardSearch", this.searchType);
    this.$router.push("/innerPage");
  }

  getEmployer() {
    let data = {
      provider: Constant.EMPLOYER_PROVIDER,
    };
    let loader = this.$loading.show();
    EmployerService.getCurrentEmployer(data).then((response) => {
      loader.hide();
      if (response != undefined && response.data != undefined) {
        if (response.data.status == 200) {
          if (response.data.data != undefined && response.data.data != null) {
            if (response.data.data.status != Constant.DE_ACTIVE && response.data.data.queryStatus != Constant.DENIED && (
              response.data.data.status == Constant.ACTIVE ||
              response.data.data.queryStatus == Constant.SUBMITTED ||
              response.data.data.queryStatus == Constant.UPDATED)
            ) {
              localStorage.setItem("empId", response.data.data.id);
              localStorage.setItem(
                "empReferenceId",
                response.data.data.referenceEmployerId
              );
              localStorage.setItem("empName", response.data.data.username);
              if(response.data.data.email != undefined && response.data.data.email != null && response.data.data.email != "" && response.data.data.hrdfType == 'Non-registered')
            localStorage.setItem("empEmail", response.data.data.email);
          else
            localStorage.setItem("empEmail", response.data.data.website);
              if (response.data.data.status == Constant.INACTIVE) {
                this.$router.push("/employerProfile");
              } else {
                this.$router.push("/employerDashboard");
              }
            }
          } else {
            this.$fire({
              title: 'Error',
              text: "Could not login...",
              showCancelButton: false,
              confirmButtonText: 'OK',
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `
            });
          }
        }
      }
    });
  }
  getJobseeker() {
    let loader = this.$loading.show();
    JobseekerService.getCurrentJobseeker().then((response) => {
      loader.hide();
      if (response != undefined && response.data != undefined) {
        if (response.data.status == 200) {
           if(response.data.data.status == Constant.INACTIVE){
            this.$fire({
              title: 'Success',
              text: "Kindly Activate your account through E-mail",
              showCancelButton: false,
              confirmButtonText: 'OK',
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `
            });
          }else{
          localStorage.setItem("loginType", "jobseeker");
          localStorage.setItem("profileId", response.data.data.id);
          localStorage.setItem("candName", response.data.data.candidateName);
          localStorage.setItem("candEmail", response.data.data.email);
          localStorage.setItem("icNumber",response.data.data.icNumber);
          if (response.data.data.keySkills != null) {
            localStorage.setItem(
              "jobseekerSkills",
              response.data.data.keySkills
            );
          }
           if(response.data.data.roleType != Constant.EMPLOYEE_ROLE){
            if(response.data.data.status == Constant.DE_ACTIVE)
              this.$fire({
              title: 'Error',
              text: "Your account has been De-activated. Kindly contact admin.",
              showCancelButton: false,
              confirmButtonText: 'OK',
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `
              });
            else
              this.$router.push("/individualDashboard");
          }else{
            this.$fire({
              title: 'Error',
              text: "Only Individuals could be Login...",
              showCancelButton: false,
              confirmButtonText: 'OK',
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `
              });
          }
        }} else {
          this.$fire({
              title: 'Error',
              text: "Could not login...",
              showCancelButton: false,
              confirmButtonText: 'OK',
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `
              });
        }
      }
    });
  }
  getAdmin() {
    let data = {
      provider: Constant.ADMIN_PROVIDER,
    };
    let loader = this.$loading.show();
    AdminService.getCurrentAdminUser(data).then((response) => {
      loader.hide();
      if (response != undefined && response.data != undefined) {
        if (response.data.status == 200) {
          localStorage.setItem(
            "referenceId",
            response.data.data.referenceAdminId
          );
          localStorage.setItem("adminName", response.data.data.fullName);
          localStorage.setItem("adminEmail", response.data.data.email);
          localStorage.setItem("lastLogin", response.data.data.lastLoginAt);
          this.$router.push("/jobseekerList");
        } else {
          this.$fire({
              title: 'Error',
              text: "Could not login...",
              showCancelButton: false,
              confirmButtonText: 'OK',
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `
          });
        }
      }
    });
  }
  getTotalJobssekersCount() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
    };
    JobseekerService.getTotalJobseekerCountForHomePage(data).then(
      (response) => {
        loader.hide();
        if (response != undefined) {
          if (response.status == 200) {
            if (
              response.data != undefined &&
              response.data != null &&
              response.data.data != undefined &&
              response.data.data != null
            )
              if (response.data.data.count != null) {
                this.totalJobseekerCount = response.data.data.count;
              } else {
                this.totalJobseekerCount = 0;
              }
          }
        }
      }
    );
  }

  getTotalPostJobscount() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
    };
    JobpostService.getTotalJobpostCountForHomePage(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null
          )
            if (response.data.data.count != null) {
              this.totalPostJobCount = response.data.data.count;
            } else {
              this.totalPostJobCount = 0;
            }
        }
      }
    });
  }
  getTotalCompaniesCount() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
    };
    EmployerService.getTotalCompaniesCountForHomePage(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null
          )
            if (response.data.data.count != null) {
              this.totalCompaniesCount = response.data.data.count;
            } else {
              this.totalCompaniesCount = 0;
            }
        }
      }
    });
  }
  getApprovedEmployers() {
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
      page: this.page,
      status: "ACTIVE",
    };
    let loader = this.$loading.show();
    EmployerService.getAllEmployersByStatus(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null
          )
            if (response.data.data.count != null) {
              this.totalApprovedEmployerCount = response.data.data.count;
            }
          if (response.data.data.employer != null) {
            this.employers = response.data.data.employer;
          } else {
            this.employers = [];
          }
        }
      }
    });
  }

  getTopCourses(){
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,"category_id": this.currentTab
    };
    let loader = this.$loading.show();
    UpSkillService.getTopCoursesCatagory(data).then((response) => {
      loader.hide();    
      if (response != undefined) {
        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null
          )
          if (response.data.data.data != null) {
            this.topCourses = response.data.data.data;
          } else {
            this.topCourses = [];
          }
        }
      }
      
    });
    
  }

  getTotalCoursesCount() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
    };
    UpSkillService.getTotalCoursesCountForHomePage(data).then(
      (response) => {
        loader.hide();

        if (response != undefined) {
          if (response.data.statusCode == 200) {
            if (
              response.data != undefined &&
              response.data != null 
            )
            // debugger;
              if (response.data.totalCount != null) {
                this.totalAvailableCourses = this.convertToStandardNoFormat(
                  response.data.totalCount[0].totalCourse
                );
                  this.totalAvailableTrainingProvider = this.convertToStandardNoFormat(
                  response.data.totalCount[0].totalTraningProvider
                );

                 this.totalAvailableApplication = this.convertToStandardNoFormat(
                  response.data.totalCount[0].totalApplicant
                );
                
                 this.totalAvailableAgency = this.convertToStandardNoFormat(
                  response.data.totalCount[0].totalAgency
                );
                //  this.totalKeySkills = this.convertToStandardNoFormat(
                //   response.data.totalCount[0].totalKeySkills
                // );
                this.totalKeySkills = this.convertToStandardNoFormat(
                  response.data.totalCount[0].totalCourseSkill
                );
              } 
             
             else {
                this.totalAvailableCourses = 0;
              }
          }
        }
      }
    );
  }
  
    getTotalCoursesDetails(flag) {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
      is_satellite_event :0,
      menu:'home'
    };
    UpSkillService.gethomeCourseCount(data).then(
      (response) => {
        loader.hide();


        if (response != undefined) {
          if (response.data.statusCode == 200) {
            if (
              response.data != undefined &&
              response.data != null 
            )
           {
             this.courseList=response.data.data.data.courses.data;
             this.courseLength = this.courseList.length
           }
          }
        }
      }
    );
  }

  getTrendingCoursesDetails(flag) {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
      filter:flag,
      menu:'home'
    };
    UpSkillService.getTrendingCourseCount(data).then(
      (response) => {
        loader.hide();


        if (response != undefined) {
          if (response.data.statusCode == 200) {
            if (
              response.data != undefined &&
              response.data != null 
            )
           {
             this.trendingList=response.data.data.data.data;
             this.trendingCourseLength = this.trendingList.length
           }
          }
        }
      }
    );
  }

  getSatelliteEventsRegion() {
    // let loader = this.$loading.show();
    let data = {
      is_satellite_event :1,
      provider: Constant.JOBSEEKER_PROVIDER,
    };
    UpSkillService.getSatelliteEventsRegion(data).then(
      (response) => {
        // loader.hide();


        if (response != undefined) {
          if (response.data.statusCode == 200) {
            if (
              response.data != undefined &&
              response.data != null 
            )
           {
             this.states=response.data.data.data;
             this.stateOptions = this.states.map(state => ({ value: state.state, title: state.state }));
             this.getSatelliteEvents(this.states[0].state);
           }
          }
        }
      }
    );
  }
  
  getSatelliteEvents(newTab) {
    // let loader = this.$loading.show();
    if (!newTab) return;
    let obj = {
      provider: Constant.JOBSEEKER_PROVIDER,
      // state: newTab,
      is_satellite_event :1,
    };
    UpSkillService.gethomeCourseCount(obj).then(
      (response) => {
        // loader.hide();


        if (response != undefined) {
          if (response.data.statusCode == 200) {
            if (
              response.data != undefined &&
              response.data != null
            )
           {
            //  this.courseList=response.data.data.data.courses.data;
            //  this.courseLength=this.courseList.length;
            // this.states = state;
            this.events = response.data.data.data.courses.data;
            this.selectedState = newTab;
            this.eventsLength = this.events.length
            // console.log(response.data.data.numOfPages)
            // console.log(this.events);
           }
          }
        }
      }
    );
  }

  // getSatelliteEvents(state: any) {
  //   // let loader = this.$loading.show();
  //   if (!state) return;
  //   let obj = {
  //     provider: Constant.JOBSEEKER_PROVIDER,
  //     state: state,
  //   };
  //   UpSkillService.getSatelliteEvents(obj).then(
  //     (response) => {
  //       // loader.hide();


  //       if (response != undefined) {
  //         if (response.data.statusCode == 200) {
  //           if (
  //             response.data != undefined &&
  //             response.data != null
  //           )
  //          {
  //           //  this.courseList=response.data.data.data.courses.data;
  //           //  this.courseLength=this.courseList.length;
  //           // this.states = state;
  //           this.events = response.data.data.data;
  //           this.selectedState = state;
  //           console.log(response.data.data.numOfPages)
  //           console.log(this.events);
  //          }
  //         }
  //       }
  //     }
  //   );
  // }


  getElearningTrendingCourse() {
    // let loader = this.$loading.show();
 
    let obj = {
      provider: Constant.JOBSEEKER_PROVIDER,
      search: '',
    };
    UpSkillService.getElearningTrendingCourse(obj).then(
      (response) => {
        // loader.hide();

        
        if (response != undefined) {
          if (response.data.statusCode == 200) {
            if (
              response.data != undefined &&
              response.data != null
            )
           {
            //  this.courseList=response.data.data.data.courses.data;
            // //  this.courseLength=this.courseList.length;
            // // this.states = state;
            // this.events = response.data.data.data;
            // this.selectedState = state;
            // console.log(response.data.data.numOfPages)
            // console.log(this.events);
           }
          }
        }
      }
    );
  }

  getPageVisitCount() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
    };
    UpSkillService.getPageVisitCount(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null &&
            response.data.data.data != undefined &&
            response.data.data.data != null
          )
            if (response.data.data.data.count != null) {
              this.totalPageVisit = this.convertToStandardNoFormat(response.data.data.data.count);
            } else {
              this.totalPageVisit = 0;
            }
        }
      }
    });
  }

  getBanner() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
      lang: this.selectedLanguage,
    };
    UpSkillService.getBanner(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null &&
            response.data.data.data != undefined &&
            response.data.data.data != null
          )
            if (response.data.data.data != null) {
              this.bannerList = response.data.data.data;
            } else {
              this.bannerList = null;
            }
        }
      }
    });
  }

  getPartners() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
    };
    UpSkillService.getPartners(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null &&
            response.data.data.data != undefined &&
            response.data.data.data != null
          )
            if (response.data.data.data != null) {
              this.eLearningData = response.data.data.data;
            } else {
              this.eLearningData = null;
            }
        }
      }
    });
  }

  handleAccordionClick(index) {
    this.events = [];
  }
  handleAccordionInput(index, isVisible, state) {
    if (isVisible) {
      this.getSatelliteEvents(state);
    }
  }
  convertToStandardNoFormat(count) {
    // let res = count.toString();
    // if (count.length == 4) {
    //   res = count.slice(0, 1) + "," + count.slice(1, count.length);
    // } else if (count.length == 5) {
    //   res = count.slice(0, 2) + "," + count.slice(2, count.length);
    // } else if (count.length == 6) {
    //   res =
    //     count.slice(0, -3) +
    //     "," +
    //     count.slice(-3);
    //   }
    // return res;
    if (typeof count !== "number" && typeof count !== "string") return count;
    const numStr = count.toString();
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }


  destroyed() {
    window.removeEventListener("keyup", this.captureEnterEvent);
  }

  captureEnterEvent(e) {
    if (e.keyCode === 13 && this.$router.currentRoute.path == "/") {
      this.searchJob();
    }
  }

  visitorPoll() {
    let option = this.option;
  }
  searchJob() {
    if (
      this.jobsearch.keyword != undefined &&
      this.jobsearch.keyword != null &&
      this.jobsearch.keyword != ""
    ) {
      this.skillError = false;
      if (this.searchType == "Jobs") this.getJobs();
      else this.getCourses();
    } else {
      this.skillError = true;
    }
  }

  searchCourse() {
    if (
      this.searchkeyword != undefined &&
      this.searchkeyword != null &&
      this.searchkeyword != ""
    ) {
      this.skillError = false;
      localStorage.setItem("homeSearch",this.searchkeyword);
      this.$router.push('/courseList');
    }
      else {
      this.skillError = true;
    }
  }

  searchJobByLocation(location) {
    this.jobsearch = new JobAdvancedSearch();
    this.jobsearch.location = location;
    this.getJobs();
  }
  searchJobByJobCategory(jobCategory) {
    this.jobsearch = new JobAdvancedSearch();
    this.jobsearch.jobcategory = jobCategory;
    this.getJobs();
  }

  getJobs() {
    localStorage.setItem("searchJobSkills", JSON.stringify(this.jobsearch));
    localStorage.setItem("dashboardSearch", this.searchType);
    this.$router.push("/innerPage");
  }
  getCourses() {
    localStorage.setItem("searchCourse", this.jobsearch.keyword);
    localStorage.setItem("dashboardSearch", this.searchType);
    this.$router.push("/innerPage");
  }



  getImgUrl(image) {
    var images = require.context("../../../assets/jobs/", false);
    return images("./" + image);
  }
  getImgUrlState(image) {
    var images = require.context("../../../assets/images/state", false);
    return images("./" + image);
  }
  getImgEmployUrl(image) {
    var images = require.context("../../../assets/employ/", false);
    return images("./" + image);
  }
  replaceUrl(attachments) {
    if (
      attachments != undefined &&
      attachments != null &&
      attachments.length > 0
    ) {
      let url: string = "";
      attachments.forEach((element) => {
        if (element.fileType == "Logo") {
          if (
            element.fileUrl != undefined &&
            element.fileUrl != null &&
            element.fileUrl != ""
          ) {
            url = element.fileUrl.replace(
              Constant.OSSInternalURL,
              Constant.OSSReplaceURL
            );
            return url;
          }
        }
      });
      return url;
    } else {
      return "";
    }
  }
  redirectToJobseekerSignup(){
     this.$router.push("/individualSignup");
  }
  redirectToEmployerSignup(){
     this.$router.push("/employSignup");
  }

 bannerImage(data:any[]){
      for (let index = 0; index < data.length; index++) {
          if (data[index].fileType == "courseBanner") {
                let url = "";
          if (
            data[index].fileUrl != undefined && data[index].fileUrl != null && data[index].fileUrl != ""
          ) {
            url = data[index].fileUrl.replace(
              Constant.OSSInternalURL,
              Constant.OSSReplaceURL
            );
            return url;
          }
          }
      }
      return null;
 }

   courseDetails(id){
    localStorage.setItem("courseId",id)
    this.$router.push("/courseDetails?courseId="+id);
  }

    replaceUrlSkill(fileData:any) {
      let adFileUrl = fileData.fileUrl;
        let url = "";
          if (
            adFileUrl != undefined && adFileUrl != null && adFileUrl != ""
          ) {
            url = adFileUrl.replace(
              Constant.OSSInternalURL,
              Constant.OSSReplaceURL
            );
            return url;
          }
  }

     twoDigits(value:any) {		
		   return parseFloat(value).toFixed(1);
    }

    randomImage(){
      return RandomImageService.randomImage();
    }

    randomCpImage(){
      return RandomImageService.randomCpImage();
    }

    redirectToEquick() {
      this.$router.push("/courseList");
      localStorage.setItem("homeSearch",'eQuick Learn')
    }

    redirectToFin2u() {
      this.$router.push("/courseList");
      localStorage.setItem("homeSearch",'Fin2u')
    }

    redirectToAlibaba() {
      this.$router.push("/courseList");
      localStorage.setItem("homeSearch",'Bayu Irawan')
    }

    redirectToMetalloy() {
      this.$router.push("/courseList");
      localStorage.setItem("homeSearch",'Metalloy')
    }

    redirectToDiri() {
      this.$router.push("/courseList");
      localStorage.setItem("homeSearch",'DIRI TECHNOLOGIES')
    }

    redirectToAmazon() {
      this.$router.push("/courseList");
      localStorage.setItem("homeSearch",'Amazon Web Services Malaysia')
    }

    redirectToWwwfSingapore() {
      this.$router.push("/courseList");
      localStorage.setItem("homeSearch",'WWF Singapore')
    }

    redirectToTransNeuron() {
      this.$router.push("/courseList");
      localStorage.setItem("homeSearch",'Trans Neuron')
    }

    redirectToElearning(url, title) {
      if(url){
        this.$router.push("/"+url);
        localStorage.setItem("homeSearch",title)
      }
      // if(thisId == 1) {
      //   this.$router.push("/courseList?eLearningProvider=AWANTEC SYSTEMS SDN. BHD.");
      //   localStorage.setItem("homeSearch",'Awantec')
      // } else if (thisId == 2) {
      //   this.$router.push("/courseList??eLearningProvider=RESKILLS EDTECH SDN. BHD.");
      //   localStorage.setItem("homeSearch",'Reskills Edtech')
      // } else if (thisId == 3) {
      //   this.$router.push("/courseList?eLearningProvider=e-Latih");
      //   localStorage.setItem("homeSearch",'e-Latih')
      // } else if (thisId == 4) {
      //   this.$router.push("/courseList?eLearningProvider=EQUICK LEARN SDN. BHD.");
      //   localStorage.setItem("homeSearch",'eQuick Learn')
      // } else if (thisId == 5) {
      //   this.$router.push("/courseList?eLearningProvider=FIN2U DIGITAL SDN. BHD.");
      //   localStorage.setItem("homeSearch",'Fin2u')
      // } else if (thisId == 6) {
      //   this.$router.push("/courseList?eLearningProvider=Ali Baba");
      //   localStorage.setItem("homeSearch",'Ali Baba')
      // } else if (thisId == 7) {
      //   this.$router.push("/courseList");
      //   localStorage.setItem("homeSearch",'Metalloy')
      // } else if (thisId == 8) {
      //   this.$router.push("/courseList");
      //   localStorage.setItem("homeSearch",'DIRI TECHNOLOGIES')
      // } else if (thisId == 9) {
      //   this.$router.push("/courseList?eLearningProvider=Redbeat Academy");
      //   localStorage.setItem("homeSearch",'Redbeat Academy')
      // } else if (thisId == 10) {
      //   this.$router.push("/courseList");
      //   localStorage.setItem("homeSearch",'Harvard Business School Publishing Corporate Learning')
      // } else if (thisId == 11) {
      //   this.$router.push("/courseList");
      //   localStorage.setItem("homeSearch",'Linkedin Learning')
      // } else if (thisId == 12) {
      //   this.$router.push("/courseList");
      //   localStorage.setItem("homeSearch",'Accenture')
      // } else if (thisId == 13) {
      //   this.$router.push("/courseList");
      //   localStorage.setItem("homeSearch",'Udacity')
      // } else if (thisId == 14) {
      //   this.$router.push("/courseList");
      //   localStorage.setItem("homeSearch",'Emeritus')
      // } else if (thisId == 15) {
      //   this.$router.push("/courseList?eLearningProvider=Microsoft (Malaysia) Sdn Bhd");
      //   localStorage.setItem("homeSearch",'Microsoft (Malaysia)')
      // } else if (thisId == 16) {
      //   this.$router.push("/courseList?eLearningProvider=PEOPLE PROWESS SDN BHD");
      //   localStorage.setItem("homeSearch",'Udemy')
      // } else if (thisId == 17) {
      //   this.$router.push("/courseList");
      //   localStorage.setItem("homeSearch",'FutureLearn')
      // } else if (thisId == 18) {
      //   this.$router.push("/courseList");
      //   localStorage.setItem("homeSearch",'OpenLearning Global')
      // } else if (thisId == 19) {
      //   this.$router.push("/courseList?eLearningProvider=ELEARNINGMINDS GROUP SDN. BHD.");
      //   localStorage.setItem("homeSearch",'eLearningMinds')
      // } else if (thisId == 20) {
      //   this.$router.push("/courseList?eLearningProvider=KNOLSKAPE SOLUTIONS SDN. BHD.");
      //   localStorage.setItem("homeSearch",'Knolskape')
      // } else if (thisId == 21) {
      //   this.$router.push("/courseList");
      //   localStorage.setItem("homeSearch",'Coursera')
      // } else if (thisId == 22) {
      //   this.$router.push("/courseList?eLearningProvider=THULIJA TECHNOLOGIES SDN. BHD.");
      //   localStorage.setItem("homeSearch",'Thulija')
      // } else if (thisId == 23) {
      //   this.$router.push("/courseList");
      //   localStorage.setItem("homeSearch",'edX')
      // } else if (thisId == 24) {
      //   this.$router.push("/courseList");
      //   localStorage.setItem("homeSearch",'AverNoble')
      // } else if (thisId == 25) {
      //   this.$router.push("/courseList?eLearningProvider=TRAINOCATE (M) SDN. BHD.");
      //   localStorage.setItem("homeSearch",'Trainocate')
      // } else if (thisId == 26) {
      //   this.$router.push("/courseList?eLearningProvider=OUTCLASS EDUCATION TECHNOLOGY AND EMPLOYMENT SERVICES SDN. BHD.");
      //   localStorage.setItem("homeSearch",'Outclass')
      // } else if (thisId == 27) {
      //   this.$router.push("/courseList?eLearningProvider=GARRANTO ACADEMY SDN. BHD.");
      //   localStorage.setItem("homeSearch",'GarrantoAcademy')
      // }else if (thisId == 28) {
      //   this.$router.push("/courseList?eLearningProvider=ASEA-TECH MSC SDN. BHD.");
      //   localStorage.setItem("homeSearch",'Asea-Tech')
      // }else if (thisId == 29) {
      //   this.$router.push("/courseList?eLearningProvider=MyDIGITAL Corporation");
      //   localStorage.setItem("homeSearch",'MyDIGITAL Corporation')
      // }else if (thisId == 30) {
      //   this.$router.push("/courseList?eLearningProvider=MEREKA INNOVATIVE EDUCATION SDN. BHD.");
      //   localStorage.setItem("homeSearch",'Mereka Innovative Education')
      // }
    }

    originUrl() {
      return window.location.origin+'/map/viewer/index.php?code=645a608374a44';
    }

    redirectToCourseList(id:any) {
      this.$router.push("/courseList");
    }
    
    redirectToEnrolments(id:any) {
      this.$router.push("/enrolments");
    }

    redirectToCourseDetails(id:any) {
      const currentUrl = window.location.href;
      const searchString = "platform";
      const avail = currentUrl.includes(searchString);
      if (avail == true) {
        const route = `/platform/courseDetails?courseId=${id}`;
        // this.$router.push(route);
        localStorage.setItem("courseId", id);
        window.open(route, '_blank');
      } else {
        const route = `/courseDetails?courseId=${id}`;
        // this.$router.push(route);
        localStorage.setItem("courseId", id);
        window.open(route, '_blank');
      }
    }

    redirectToCourseProviderList() {
      this.$router.push("/courseProviderList");
    }
    
    redirectToSkillList() {
      this.$router.push("/skillList");
    }

    redirectToPillarCourseList(id) {
      this.$router.push("/courseList?pillarId="+id);
    }

    formatCurrency(value) {
        if (value != null) {
            const numberValue = parseFloat(value);
            if (!isNaN(numberValue)) {
                return 'RM ' + numberValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
        }
        return 'RM 0.00';
    }

    formatRating(value) {
        if (value != null) {
            const numberValue = parseFloat(value);
            if (!isNaN(numberValue)) {
                return numberValue.toFixed(2);
            }
        }
        return '0';
    }

    redirectToRegistration() {
      this.$router.push("/individualSignup");
    }

    redirectTo(thisLink) {
      window.open(thisLink, "_blank");
    }


    getTranslate(lang, desc) {
      try {
        if(desc != '' && desc != null){
          const list = JSON.parse(desc || '[]');
          const found = list.find(item => item[lang]);
          return found ? found[lang] : '';
        }
        return '';
      } catch (e) {
        return '';
      }
    }
}

